import { createAction } from 'redux-actions';

import {
  LOAD_FEATURE_LIST,
  LOAD_FEATURE_LIST_SUCCESS,
  LOAD_FEATURE_LIST_ERROR,
} from './type';

//Load list patient
export const loadFeatureListAction = createAction(LOAD_FEATURE_LIST);
export const loadFeatureListSuccessAction = createAction(
  LOAD_FEATURE_LIST_SUCCESS,
);
export const loadFeatureListErrorAction = createAction(LOAD_FEATURE_LIST_ERROR);
